export const featureDatageneralContracting = {
    mainTitle: 'Why Choose HRD for General Contracting?',
    items: [
        {
            number: '01',
            heading: 'Experienced & Skilled Team – Certified professionals delivering top-quality workmanship.'
        },
        {
            number: '02',
            heading: 'Seamless Project Execution – We handle everything from planning to completion, ensuring a smooth and stress-free process.'
        },
        {
            number: '03',
            heading: 'Cost-Effective & Efficient – Maximizing quality and value while staying within budget and schedule.'
        },
        {
            number: '04',
            heading: 'Safety & Compliance – Adhering to all local building codes, WorkSafeBC standards, and industry regulations.'
        },
        {
            number: '05',
            heading: 'Minimal Business Disruption – Strategic scheduling and efficient workflows to limit downtime and operational impact.'
        }
    ],
    title: "Build with ConfidenceFrom",
    subtitle:
        'commercial upgrades and high-rise restorations to tenant improvements and structural repairs, HRD delivers high-quality, reliable, and efficient general contracting solutions.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/7generalContracting/featuregridSection/fondo.png'
};
